var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_281_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "matrix(0 1 1 0 0 0)",
    fill: "url(#paint0_linear_281_2)",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 15.856C11.862 15.46 11.628 14.974 11.628 14.398C11.628 14.038 11.706 13.708 11.862 13.408C12.03 13.108 12.234 12.862 12.474 12.67C12.714 12.478 12.972 12.28 13.248 12.076C13.536 11.86 13.8 11.662 14.04 11.482C14.28 11.302 14.478 11.086 14.634 10.834C14.802 10.582 14.886 10.306 14.886 10.006C14.886 9.526 14.7 9.13 14.328 8.818C13.968 8.494 13.446 8.332 12.762 8.332C11.598 8.332 10.644 8.824 9.9 9.808L9 8.836C9.948 7.612 11.25 7 12.906 7C13.974 7 14.826 7.27 15.462 7.81C16.11 8.338 16.434 8.998 16.434 9.79C16.434 10.402 16.248 10.948 15.876 11.428C15.516 11.896 15.12 12.256 14.688 12.508C14.256 12.76 13.854 13.06 13.482 13.408C13.122 13.756 12.942 14.122 12.942 14.506C12.942 14.842 13.104 15.136 13.428 15.388L12.33 15.856ZM13.392 19.078C13.2 19.27 12.972 19.366 12.708 19.366C12.444 19.366 12.21 19.27 12.006 19.078C11.814 18.886 11.718 18.652 11.718 18.376C11.718 18.1 11.814 17.866 12.006 17.674C12.21 17.482 12.444 17.386 12.708 17.386C12.972 17.386 13.2 17.482 13.392 17.674C13.596 17.866 13.698 18.1 13.698 18.376C13.698 18.652 13.596 18.886 13.392 19.078Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_281_2",
    x: -42,
    y: -42,
    width: 109,
    height: 109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_281_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_281_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_281_2",
    x1: 0,
    y1: 0,
    x2: 15.2842,
    y2: 29.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.c121df2ce0a2c20f123c704175976c4a.svg";
export { ForwardRef as ReactComponent };